import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    links = "links",
    numberOfTabs = "numberOfTabs",
}

const mapStateToProps = (state: ApplicationState) => ({
    currentLocation: getLocation(state),
});

const mapDispatchToProps = {};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;
interface LinkModel {
    fields: {
        title: string;
        description: string;
        logoImage: string;
        children?: LinkModel[];
    };
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.links]: LinkModel[];
    };
}

// type Props = OwnProps;

export interface SupportStyles {
    container?: GridContainerProps;
    mainGridContainer: GridItemProps;
    categoryImageItem?: GridItemProps;
    categoryImage?: LazyImageProps;
    textGridItem?: GridItemProps;
    titleGridItem?: GridItemProps;
    titleLabel?: TypographyPresentationProps;
    descriptionGridItem?: GridItemProps;
    descriptionText?: TypographyPresentationProps;
}

export const supportStyles: SupportStyles = {
    container: {
        css: css`
            width: 100%;
            padding: 2rem 4rem;
            margin: 0 auto;
            background: #fff;
            > ${GridOffset} {
                width: 100%;
                padding: 0;
                margin: 0 auto;
            }
        `,
    },
    mainGridContainer: {
        width: [12, 6, 6, 4, 3],
        css: css`
            padding: 0;
            display: flex;
            align-items: center;
            margin: 1rem 0px !important;
            > ${GridOffset} {
                width: 100%;
                padding: 0;
                margin: 0 auto;
            }
        `,
    },

    categoryImageItem: {
        width: 4,
        css: css`
            padding: 0px;
            justify-content: center;
            align-items: center;
        `,
    },
    categoryImage: {
        width: "80px",
        height: "80px",
        css: css`
            border-radius: 50%;
            opacity: 1;
            z-index: 98;
            background: #f0f4f3;

            img {
                z-index: 99;
                height: 50% !important;
            }
        `,
    },
    textGridItem: {
        width: 8,
        css: css`
            flex-direction: column;
            padding: 0px;
        `,
    },
    titleGridItem: {
        width: 12,
        css: css`
            padding: 5px;
        `,
    },
    titleLabel: {
        size: 18,
        weight: "bold",
    },
    descriptionGridItem: {
        width: 12,
        css: css`
            padding: 5px;
        `,
    },
    descriptionText: {
        size: 14,
        css: css`
            padding: 0px;
        `,
    },
};

const styles = supportStyles;
export const GAIASupportStrip = ({ fields, currentLocation }: Props) => {
    const url = currentLocation.pathname + currentLocation.search;
    return (
        <>
            {url === "/" ? (
                <StyledWrapper>
                    <GridContainer {...styles.container}>
                        {fields.links.map((destinationLink, index) => (
                            <>
                                <GridItem {...styles.mainGridContainer}>
                                    {destinationLink.fields.logoImage && (
                                        <GridItem {...styles.categoryImageItem}>
                                            <LazyImage
                                                src={destinationLink.fields.logoImage}
                                                className="category-image"
                                                altText="Icon"
                                                {...styles.categoryImage}
                                            />
                                        </GridItem>
                                    )}
                                    <GridItem {...styles.textGridItem}>
                                        {destinationLink.fields.title && (
                                            <GridItem {...styles.titleGridItem}>
                                                <Typography {...styles.titleLabel}>
                                                    {destinationLink.fields.title}
                                                </Typography>
                                            </GridItem>
                                        )}
                                        {destinationLink.fields.description && (
                                            <GridItem {...styles.descriptionGridItem}>
                                                <Typography {...styles.descriptionText}>
                                                    {destinationLink.fields.description}
                                                </Typography>
                                            </GridItem>
                                        )}
                                    </GridItem>
                                </GridItem>
                            </>
                        ))}
                    </GridContainer>
                </StyledWrapper>
            ) : null}
        </>
    );
};

const widgetModule: WidgetModule = {
    // component: GAIASupportStrip,
    component: connect(mapStateToProps, mapDispatchToProps)(GAIASupportStrip),
    definition: {
        group: "Basic",
        displayName: "GAIA Support Strip",
        fieldDefinitions: [
            {
                name: fields.links,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.title;
                },
                defaultValue: [],
                fieldType: "General",
                fieldDefinitions: [
                    {
                        name: "title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "description",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "logoImage",
                        displayName: "Logo Image",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
